import React, { useState, useRef } from "react";
import Navbar from "./Navbar";

import { useNavigate } from "react-router-dom";


const customLinks = [
  { href: "/", label: "Home" },
  { href: "/#about", label: "About Us" },
  { href: "/#services", label: "Our Service" },
  { href: "/#newsletter", label: "Contact Us" },
];

const CustomerSection = () => {
  const navigate = useNavigate();
  const attendanceRef = useRef(null);
  const [search, setSearch] = useState("");

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar links={customLinks} />

<main className="flex-1 container mx-auto flex flex-col gap-8 px-4 py-8 md:max-w-full lg:max-w-[90rem]">
        <div className="flex flex-col items-center justify-center text-center bg-gray-50 rounded-lg shadow-md py-30">
          
            <>
              <h1 className="text-3xl sm:text-4xl font-bold text-gray-800">
                Customer Dashboard
              </h1>
           
            </>
          
        </div>

        {/* Sections */}
        <div ref={attendanceRef} className="flex flex-col items-start justify-center text-center lg:min-h-[70vh] mb-20">
          <h1 className="text-4xl font-semibold text-gray-800 mb-12">
            Tracking
          </h1>
          <div className="flex flex-1 flex-col justify-center items-center w-full">
           <div className="flex flex-col w-1/2 sm:flex-row items-center justify-between mb-4 gap-2">
             <input
               type="text"
               placeholder="Search by name, id or tracking number..."
               className="px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring focus:ring-blue-200 flex-1"
               value={search}
               onChange={(e) => {
                 setSearch(e.target.value);
                 setPage(1);
               }}
             />
             <button
               className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 cursor-pointer"
               onClick={() => setShowModal(true)}
             >
               Track
             </button>
           </div>
            <div className="flex flex-1 flex-col justify-center items-center w-full">
              <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28877.57445156856!2d55.2707826!3d25.2048493!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f4346d0f3d3f9%3A0x9f8e9b4e4f2f0d9!2sDubai%20-%20United%20Arab%20Emirates!5e0!3m2!1sen!2sus!4v1695483900000!5m2!1sen!2sus"
                  width="100%"
                  height="500"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                >
                </iframe>

            </div>


          </div>
        </div>

    


        
      </main>
    </div>
  );
};

export default CustomerSection;
